// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"55":"16d5ab4d","7177":"16d5ab4d"}[chunkId] + ".chunk.css";
};